import * as React from 'react';

import {
    ContextualMenu,
    DirectionalHint,
    IContextualMenuItem,
} from 'office-ui-fabric-react/lib/components/ContextualMenu';
import { FONT_SIZE_LIST } from 'owa-format-options';

let styles = require('./Ribbon.scss');
let classNames = require('classnames');

export interface FontSizePickerProps {
    menuTargetElement: HTMLElement;
    onDismissMenu: () => void;
    onSelectSize: (size: string) => void;
    selectedSize?: string;
    shouldFocusOnMount?: boolean;
}

export default class FontSizePicker extends React.Component<FontSizePickerProps, {}> {
    private createMenuItems(): IContextualMenuItem[] {
        let menuItems: IContextualMenuItem[] = [];
        let checkComplete: boolean = this.props.selectedSize ? false : true;
        FONT_SIZE_LIST.forEach((item: string) => {
            let isChecked: boolean = checkComplete ? false : this.props.selectedSize == item;
            if (isChecked) {
                checkComplete = true;
            }
            menuItems.push({
                key: item,
                name: item,
                data: item,
                checked: isChecked,
                canCheck: true,
                onClick: () => this.onSelectSize(item),
            });
        });

        return menuItems;
    }

    private onSelectSize = (fontSize: string) => {
        this.props.onDismissMenu();
        this.props.onSelectSize(fontSize);
    };

    render() {
        let { onDismissMenu, menuTargetElement, shouldFocusOnMount } = this.props;
        let items: IContextualMenuItem[] = this.createMenuItems();
        let pickerStyle = classNames(styles.fontSizePickerContainer, 'customScrollBar');
        return (
            <ContextualMenu
                className={pickerStyle}
                shouldFocusOnMount={shouldFocusOnMount}
                target={menuTargetElement}
                directionalHint={DirectionalHint.bottomLeftEdge}
                onDismiss={onDismissMenu}
                items={items}
            />
        );
    }
}
